import { theme } from 'abihome-components'

export default {
  ...theme,
  success: {
    ...theme.success,
    cc: '#4338CA'
  },
  warning: '#4338CA'
}



// WEBPACK FOOTER //
// ./src/styles/theme.js